<template>
  <div class="content">
    <header class="tabs">
      <TabSwitch
        class="TabSwitch"
        v-model="check"
        :tabs="[
          { value: 'c', label: '通话记录' },
          { value: 'b', label: '短信记录' },
          { value: 'a', label: '小结' }
        ]"
      />
      <div class="addButton" @click="showEditor" v-show="check === 'a' && patientType === 1">
        + 添加小结
      </div>
    </header>
    <TableSummary ref="SummaryDOM" v-if="check === 'a'"></TableSummary>
    <TableMessage v-else-if="check === 'b'"></TableMessage>
    <TableCommunication v-else-if="check === 'c'"></TableCommunication>
    <EditSummary @close="closeEditSummary" ref="editSummaryRef" />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import TableCommunication from './TableCommunication.vue'
import TableSummary from './TableSummary.vue'
import TableMessage from './TableMessage.vue'
import TabSwitch from '../../../components/TabSwitch.vue'
import { useStore } from 'vuex'

const check = ref('c')
const store = useStore()
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const profileInfo = computed(() => store.state.patientFile.bindUser.profileInfo)
const disease = computed(() => store.state.patientFile.disease)
const workOrderId = computed(() => store.state.patientFile.workOrderId)
const editSummaryRef = ref(null)

const showEditor = () => {
  const { ucDoctorId, doctorName } = doctorInfo.value
  const { age, patientProfileName, gender } = profileInfo.value
  const { ucPatientId } = info.value
  const params = {
    privateId: disease.value.patientGroupId,
    groupInfo: {
      patientProfileCommonVO: {
        patientProfileName,
        gender,
        age
      },
      patientName: info.value?.name,
      ucPatientId: ucPatientId,
      doctorName: doctorName,
      ucDoctorId: ucDoctorId
    },
    type: 0,
    workOrderId: workOrderId.value
  }
  editSummaryRef.value?.initModal(params)
}
const SummaryDOM = ref()
const closeEditSummary = () => {
  SummaryDOM.value.change()
}
</script>

<style lang="scss" scoped>
.content {
  background: white;
  padding: 16px;
  .tabs {
    display: flex;
    // justify-content: space-between;
    margin-bottom: 12px;
    .TabSwitch {
      // height: 38px;
    }
    .addButton {
      margin-left: 24px;
      padding: 8px 12px;
      background: rgba(24, 144, 255, 0.1);
      cursor: pointer;
      // color: white;
      color: #1890ff;
      border-radius: 4px;
      transition: all 0.2s;
      &:hover {
        background: rgba(24, 144, 255, 0.2);
      }
    }
  }
}
</style>
